(ns common.db.interceptors
  (:require [common.util :as util]
            [re-frame.core :as rf]))

(def flatten-v
  "Flatten event signature. This interceptor converts the signature
   [[& args]] into [& args]."
  (rf/->interceptor
   :id :flatten-v
   :before (fn flattenv-before [context]
             (update-in context [:coeffects :event] first))))

(def forwarded-event
  "Vector of interceptors for flatten forward event by replacing event args with forward-event args.
   This interceptor converts the signature [cofx [event [forward-event forward-args]]]
   into [cofx [forward-event forward-args]]."
  [rf/trim-v flatten-v])

(def transform-keys->kebab-case
  "Map coeffect events to kebab-case."
  (rf/->interceptor
   :id :transform-keys->kebab-case
   :before (fn transform-keys->kebab-case [context]
             (update-in context [:coeffects :event]
                        (partial map #(if (map? %)
                                        (util/m->kebab-case %)
                                        %))))))

;; Uncomment this to log all the Re-frame events to the console.
#_
(rf/reg-global-interceptor
  (rf/->interceptor
   :id :pprint-event
   :before (fn [context]
             (cljs.pprint/pprint (-> context :coeffects :original-event))
             context)))
